module.exports = __webpack_public_path__ + "img/_dsc8146.250370c5.jpg";